class AnnouncementBar extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setAttribute('loaded', '')

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()

    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.offsetHeight}px`,
    )
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [window.BAO.Carousel.useAutoplay(4, { pauseOnHover: true })],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
